module.exports = __webpack_public_path__ + "static/media/phaathit-1.d2c7c6d5.jpeg";